import React from 'react';
import Loading from '../../../commonComponents/react/Loading';

const RouterLoading = () => {
  return (<div style={{padding: 50, height: "100%", paddingBottom: 200}}><Loading size={100} /></div>)
}

export default RouterLoading;